// extracted by mini-css-extract-plugin
export default {"container":"BL-z","topReviewHeading":"CL-z","criticalReview":"DL-z","favorableReview":"EL-z","vsSeparator":"FL-z"};